import { render, staticRenderFns } from "./MunicipalitySelectionForm.vue?vue&type=template&id=c99252bc&scoped=true&"
import script from "./MunicipalitySelectionForm.vue?vue&type=script&lang=ts&"
export * from "./MunicipalitySelectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./MunicipalitySelectionForm.vue?vue&type=style&index=0&id=c99252bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99252bc",
  null
  
)

export default component.exports